let LS_CONSTANTS = {
  LS_USER_DATA: "user-data",
  LS_USER_SESSION_DATA: "user-session-data",
  LS_TRANS_DATA: "transporter-data",
};
export default LS_CONSTANTS;
